"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RateLimitError = void 0;
var tslib_1 = require("tslib");
var RateLimitError = /** @class */ (function (_super) {
    tslib_1.__extends(RateLimitError, _super);
    function RateLimitError(message, retryTimeout) {
        var _this = _super.call(this, message) || this;
        _this.retryTimeout = retryTimeout;
        _this.name = 'RateLimitError';
        return _this;
    }
    return RateLimitError;
}(Error));
exports.RateLimitError = RateLimitError;
//# sourceMappingURL=ratelimit-error.js.map